import CollectionStatus from './CollectionStatus.container'
export default CollectionStatus
